import React from "react";
import TermsAndConditions from "./TermsAndConditions";

export default function TermCondition(props) {
  return <TermsAndConditions {...props} />;
}
